var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h4',{staticClass:"notAllowed text-center"},[_vm._v("No puedes navegar por nuestra web si no estas registrado. Para registrarte llama al 953741829 y hazte cliente.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }